exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui.dropdown .menu.active {\n  display: block;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcement-edit/announcement-edit.component.css
// module id = ../../../../../src/app/announcements/announcement-edit/announcement-edit.component.css
// module chunks = main